export default __webpack_public_path__ + "static/media/bukas.fb16865b.svg";